import { MileageDataSource } from '../enum/mileageDataSource';
import { Vehicle } from '../vehicle/model/vehicle';
import { VehicleV10 } from './v10/vehicle/model/vehicleV10';
import { VehicleV11 } from './v11/vehicle/model/vehicleV11';
export class VehicleTransformer {
    static transform(inVersion, outVersion, payload) {
        const transformation = inVersion + '-to-' + outVersion;
        switch (transformation) {
            case '12-to-11':
                return this.transformFromV12ToV11(payload);
            case '11-to-12':
                return this.transformFromV11ToV12(payload);
            case '12-to-10':
                return this.transformFromV12ToV10(payload);
            case '10-to-12':
                return this.transformFromV10ToV12(payload);
            default:
                throw new Error('Unsupported transformation: ' + transformation);
        }
    }
    static transformFromV12ToV11(payload) {
        const vehicle = Vehicle.fromPlainObject(payload);
        switch (vehicle.getMileageSource()) {
            case MileageDataSource.VEHICLE_HISTORY:
                payload.mileageInKilometersFromFbm = vehicle.getCurrentMileageInKilometers();
                break;
            case MileageDataSource.KEY_READER:
            case MileageDataSource.REMOTE_KEY_READ:
            case MileageDataSource.TELESERVICES:
                payload.mileageInKilometersFromLatestKeyRead = vehicle.getCurrentMileageInKilometers();
                break;
        }
        return VehicleV11.fromPlainObject(payload);
    }
    static transformFromV11ToV12(payload) {
        const vehicleV11 = VehicleV11.fromPlainObject(payload);
        const vehicle = Vehicle.fromPlainObject(payload);
        if (vehicle.getVin7()) {
            vehicle.setCurrentMileageInKilometers(this.evaluateCurrentMileage(vehicleV11.getMileageInKilometersFromLatestKeyRead(), vehicleV11.getMileageInKilometersFromFbm()));
            const source = vehicle.getCurrentMileageInKilometers() &&
                vehicle.getCurrentMileageInKilometers() === vehicleV11.getMileageInKilometersFromFbm()
                ? MileageDataSource.VEHICLE_HISTORY
                : MileageDataSource.KEY_READER;
            vehicle.setMileageSource(vehicle.getCurrentMileageInKilometers() ? source : null);
        }
        else {
            vehicle.setCurrentMileageInKilometers(null);
            vehicle.setMileageSource(null);
        }
        return vehicle;
    }
    static transformFromV12ToV10(payload) {
        const vehicle = Vehicle.fromPlainObject(payload);
        switch (vehicle.getMileageSource()) {
            case MileageDataSource.VEHICLE_HISTORY:
                payload.mileageInKilometersFromFbm = vehicle.getCurrentMileageInKilometers();
                break;
            case MileageDataSource.KEY_READER:
            case MileageDataSource.REMOTE_KEY_READ:
            case MileageDataSource.TELESERVICES:
                payload.mileageInKilometersFromLatestKeyRead = vehicle.getCurrentMileageInKilometers();
                break;
        }
        return VehicleV10.fromPlainObject(payload);
    }
    static transformFromV10ToV12(payload) {
        const vehicleV10 = VehicleV10.fromPlainObject(payload);
        const vehicle = Vehicle.fromPlainObject(payload);
        vehicle.setCurrentMileageInKilometers(vehicle.getVin7() ? vehicleV10.getMileageInKilometers() : null);
        vehicle.setMileageSource(vehicle.getCurrentMileageInKilometers() ? MileageDataSource.VEHICLE_HISTORY : null);
        return vehicle;
    }
    static evaluateCurrentMileage(fromKeyPool, fromFbm) {
        if (fromKeyPool && fromFbm) {
            return fromKeyPool > fromFbm ? fromKeyPool : fromFbm;
        }
        else if (!fromKeyPool && !fromFbm) {
            return undefined;
        }
        else {
            return fromKeyPool || fromFbm;
        }
    }
}
//# sourceMappingURL=vehicleTransformer.js.map